import UserProfile from "cruds/user-profile";
import Tags from "cruds/settings/tags";
import UserManagement from "cruds/user-management";
import Project from "cruds/projects";
import Articles from "cruds/articles";
import Pages from "cruds/landing-page";
import Sliders from "cruds/website-management/sliders";
import Settings from "cruds/website-management/settings";
import Items from "cruds/settings/items";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
// import Analytics from "layouts/dashboards/analytics";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

// Arakan components
import MDAvatar from "components/MDAvatar";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
// import profilePicture from "assets/images/team-3.jpg";

import i18n from "i18n";
import Comments from "cruds/website-management/comments";
import DonationList from "cruds/donations/donation-list";
import {
  SettingsAccessibility,
  SettingsApplications,
  Web,
} from "@mui/icons-material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Faqs from "cruds/settings/faq";
import PartenarsReq from "cruds/settings/partenars-req";
import Logs from "cruds/admin-activities";
import Reports from "cruds/settings/reports";
import CountryAnalytics from "layouts/dashboards/analytics/CountryAnalytics";
import CatAnalytics from "layouts/dashboards/analytics/CatAnalytic";
import MainCatAnalytics from "layouts/dashboards/analytics/MainCatAnalytic";
import ProjectAnalytics from "layouts/dashboards/analytics/ProjectAnalytics";
import MonthAnalytics from "layouts/dashboards/analytics/MonthAnalytics";
import SpecialProjects from "cruds/special-projects";
import NavBar from "cruds/settings/navbar";

const { t } = i18n;

const routes = [
  {
    type: "collapse",
    name: "Bruce Mars",
    key: "user-name",
    // icon: <MDAvatar src={profilePicture} alt="Bruce Mars" size="sm" />,
    collapse: [
      {
        name: t("profile"),
        key: "user-profile",
        route: "/examples-api/user-profile",
        component: <UserProfile />,
      },
      {
        name: "Logout",
        key: "logout",
      },
    ],
  },
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: t("dashboards"),
    key: "dashboards",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      // {
      //   name: t("analytics"),
      //   key: "analytics",
      //   route: "/dashboards/analytics",
      //   component: <Analytics />,
      // },
      {
        name: "إحصائيات البلاد",
        key: "country",
        route: "/dashboards/analytics/country",
        component: <CountryAnalytics />,
        type: "donation",
      },
      // {
      //   name: "إحصائيات التصنيفات",
      //   key: "catAnalytics",
      //   route: "/dashboards/analytics/cat",
      //   component: <CatAnalytics />,
      //   type: "donation",
      // },
      // {
      //   name: "إحصائيات التصنيفات الرئيسية",
      //   key: "mainCatAnalytics",
      //   route: "/dashboards/analytics/main-cat",
      //   component: <MainCatAnalytics />,
      //   type: "donation",
      // },
      {
        name: "إحصائيات المشاريع",
        key: "project",
        route: "/dashboards/analytics/project",
        component: <ProjectAnalytics />,
        type: "donation",
      },
      {
        name: "إحصائيات الشهور",
        key: "month",
        route: "/dashboards/analytics/month",
        component: <MonthAnalytics />,
        type: "donation",
      },
    ],
  },
  { type: "title", title: t("management"), key: "crud-pages" },
  {
    type: "collapse",
    name: t("userManagement"),
    key: "user-management",
    icon: <GroupAddOutlinedIcon size="sm" />,
    collapse: [
      {
        name: t("activities"),
        key: "logs",
        route: "/system/logs",
        component: <Logs />,
        type: "system",
      },
      {
        name: t("users"),
        key: "employees",
        route: "/userManagement/employees",
        component: <UserManagement />,
        type: "users",
      },
      {
        name: t("donators"),
        key: "donators",
        route: "/userManagement/donators",
        component: <UserManagement />,
        type: "users",
      },
      {
        name: t("influencers"),
        key: "influencers",
        route: "/userManagement/influencers",
        component: <UserManagement />,
        type: "users",
      },
    ],
  },
  {
    type: "collapse",
    name: t("articlesManagement"),
    key: "article-management",
    icon: <AutoStoriesIcon fontSize="medium" />,
    collapse: [
      {
        name: t("news"),
        key: "news",
        route: "/news&bolgs/news",
        component: <Articles />,
        type: "article",
      },
      {
        name: t("blogs"),
        key: "blogs",
        route: "/news&bolgs/blogs",
        component: <Articles />,
        type: "article",
      },
    ],
  },
  {
    type: "collapse",
    name: t("websiteManagement"),
    key: "website-management",
    icon: <Web fontSize="medium" />,
    collapse: [
      {
        name: "الصفحة الرئيسية",
        key: "pages",
        route: "/websiteManagement/pages",
        component: <Pages />,
        type: "pages",
      },
      {
        name: "طلبات الشركاء",
        key: "partnership_requests",
        route: "/websiteManagement/partnership_requests",
        component: <PartenarsReq />,
        type: "partnership_requests",
      },
      {
        name: "صفحة السؤال والجواب",
        key: "faqs",
        route: "/websiteManagement/faqs",
        component: <Faqs />,
        type: "faq",
      },
      {
        name: "التقارير",
        key: "reports",
        route: "/websiteManagement/reports",
        component: <Reports />,
        type: "reports",
      },
      // {
      //   name: t("sliders"),
      //   key: "sliders",
      //   route: "/websiteManagement/sliders",
      //   component: <Sliders />,
      //   type: "settings",
      // },
      // {
      //   name: t("websiteContent"),
      //   key: "websiteSettings",
      //   route: "/websiteManagement/websiteContent",
      //   component: <Settings />,
      //   type: "settings",
      // },
      {
        name: t("comments"),
        key: "comments",
        route: "/websiteManagement/comments",
        component: <Comments />,
        type: "comments",
      },
    ],
  },
  {
    type: "collapse",
    name: t("projectManagement"),
    key: "project-management",
    icon: <AutoAwesomeIcon fontSize="medium" />,
    collapse: [
      {
        name: t("projects"),
        key: "projects",
        route: "/projectManagement/projects",
        component: <Project />,
        type: "projects",
      },
      {
        name: "عطاءات",
        key: "special",
        route: "/projectManagement/special",
        component: <SpecialProjects />,
        type: "projects",
      },
    ],
  },
  {
    type: "collapse",
    name: t("donationManagement"),
    key: "donation-management",
    icon: <VolunteerActivismIcon fontSize="medium" />,
    collapse: [
      {
        name: t("donations"),
        key: "donations-list",
        route: "/donationManagement/donations-list",
        component: <DonationList />,
        type: "donation",
      },
    ],
  },
  {
    type: "collapse",
    name: t("settings"),
    key: "settings",
    icon: <SettingsApplications fontSize="medium" />,
    collapse: [
      {
        name: "القائمة الرئيسية",
        key: "navbar",
        route: "/navbar",
        component: <NavBar />,
        type: "navbar",
      },
      {
        name: t("tags"),
        key: "tags",
        route: "/tags",
        component: <Tags />,
        type: "tags",
      },
      {
        name: t("categories"),
        key: "categories",
        route: "/projectManagement/categories",
        component: <Items />,
        type: "categories",
      },
      // {
      //   name: t("countries"),
      //   key: "countries",
      //   route: "/projectManagement/countries",
      //   component: <Items />,
      //   type: "countries",
      // },
      {
        name: t("project_status"),
        key: "project_status",
        route: "/projectManagement/project_status",
        component: <Items />,
        type: "project_status",
      },
      {
        name: t("targetSegments"),
        key: "target_segment",
        route: "/projectManagement/target_segment",
        component: <Items />,
        type: "target_segment",
      },
    ],
  },
];

export default routes;
